import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Table from '@/modules/common/components/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDateTime, getInternalStatus, formatPrice } from '~/common';
import TableRow from './TableRow';

const Component = (props) => {
    // noinspection JSUnresolvedVariable
    return (
        <TableContainer>
            <Table><TableBody>
                <TableRow name="ID заявки" value={props.lead.adv_sub}/>
                {(props.lead.offer)
                    ? <>
                        <TableRow name="ID оффера" value={props.lead.offer.offer_id}/>
                        <TableRow name="Название оффера" value={props.lead.offer.offer_name}/>
                    </>
                    : null
                }
                {(!props.user.affiliate)
                    ? <>
                        <TableRow name="ID партнера" value={props.lead.affiliate_id}/>
                        <TableRow name="Имя партнера" value={props.lead.affiliate_name}/>
                    </>
                    : null
                }
                {(props.lead.type)
                    ? <>
                        <TableRow name="Тип заявки" value={props.lead.type.code}/>
                        <TableRow name="Название типа заявки" value={props.lead.type.name}/>
                    </>
                    : null
                }
                <TableRow name="Дата/Время" value={formatDateTime(new Date(props.lead.datetime))}/>
                <TableRow name="Source" value={props.lead.source} checkNull={true}/>
                <TableRow name="Affiliate Sub" value={props.lead.aff_sub} checkNull={true}/>
                {(!props.user.affiliate)
                    ? <>
                        <TableRow name="Affiliate Sub 2" value={props.lead.aff_sub2} checkNull={true}/>
                        <TableRow name="Affiliate Sub 3" value={props.lead.aff_sub3} checkNull={true}/>
                        <TableRow name="Affiliate Sub 4" value={props.lead.aff_sub4} checkNull={true}/>
                        <TableRow name="Adv Sub" value={props.lead.adv_sub2} checkNull={true}/>
                        <TableRow name="Adv Sub 2" value={props.lead.adv_sub3} checkNull={true}/>
                        <TableRow name="Adv Sub 3" value={props.lead.adv_sub4} checkNull={true}/>
                        <TableRow name="Adv Sub 4" value={props.lead.adv_sub5} checkNull={true}/>
                    </>
                    : null
                }
                <TableRow name="Дата/Время статуса" value={formatDateTime(new Date(props.lead.datetime_status))}/>
                {(props.lead.status)
                    ? <>
                        <TableRow name="Статус" value={props.lead.status.status}/>
                        <TableRow name="Код статуса" value={props.lead.status.code}/>
                        <TableRow name="Внутренний статус" value={getInternalStatus(props.lead.status.internal)}/>
                    </>
                    : null
                }
                <TableRow name="Цена" value={props.lead.price} fmtValue={formatPrice(props.lead.price)}
                          checkNull={true}/>
                <TableRow name="ID транзакции" value={props.lead.transaction_id} checkNull={true}/>
                {(!props.user.affiliate)
                    ? <>
                        <TableRow name="Идентификатор URL" value={props.lead.url_id} checkNull={true}/>
                        <TableRow name="Комментарий" value={props.lead.comment} checkNull={true}/>
                    </>
                    : null
                }
            </TableBody></Table>
        </TableContainer>
    );
};

Component.propTypes = {
    lead: PropTypes.object.isRequired,
};

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    null
)(Component);
